import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Button, Divider } from 'antd';
import {
  FileSearchOutlined,
  FileTextOutlined,
  HistoryOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import {
  AssetSelector,
  CustomButton,
  CustomModal,
  CustomTable,
  CustomTabs,
  CustomText,
  CustomTextArea,
  useCustomToast,
} from '../../../../components';
import GDContentModalItems from '../components/contents/GDContentModalItems';
import GestorTableItems from '../components/ByRoles/GestorTableItems';
import { GoodTypes } from '../../types';

interface GoodsDetailViewProps {
  detailData?: any;
  setFooterLeft: (footer: React.ReactNode) => void;
  onVoucher?: () => void;
  onDocuments: (id: string) => void;
  onDownloadPDF: (id: string) => void;
  goodStates: any;
  goodPetitionItems?: any;
  onSaveGestor?: any;
  updateItems?: boolean;
  setUpdateItems?: any;
  formikSolicitud?: any;
  setIsResponseOk?: any;
  isResponseOk?: any;
  downloadFile?: any;
  isApproveRequest?: boolean;
  assetsList?: any;
  setAssetsList?: any;
  location?: any;
}

const GoodsDetailView: React.FC<GoodsDetailViewProps> = ({
  detailData,
  goodPetitionItems,
  formikSolicitud,
  assetsList,
  setAssetsList,
  location,
  setFooterLeft,
  onDownloadPDF,
  onDocuments,
}) => {

  // FOOTER
  React.useEffect(() => {
    setFooterLeft(
      <>
      <CustomButton
        label="Descargar documentos"
        disabled={!detailData?.documents && detailData?.documents?.length === 0}
        onClick={() => {
          onDocuments(detailData?.id || '');
        }}
        icon={<DownloadOutlined />}
        size="middle"
        buttonType="secondary"
      />

      <CustomButton
        style={{ marginLeft: '20px' }}
        label="Generar comprobante"
        disabled={detailData?.status_id !== 7}
        onClick={() => {
          onDownloadPDF(detailData?.id_petition || '');
        }}
        icon={<DownloadOutlined />}
        size="middle"
        buttonType="secondary"
      />
      </>
    );
  }, [detailData, setFooterLeft]);

  const [modalManageAll, setModalManageAll] = useState<boolean>(false);
  const [modalElements, setModalElements] = useState<boolean>(false);
  const [modalAssets, setModalAssets] = useState<boolean>(false);
  const [itemSelected, setItemSelected] = useState<any>();
  const [loadingAll, setLoadingAll] = useState(false);
  const [columTableBienes, setColumTableBienes] = useState<any>([]);
  const [columTableFijos, setColumTableFijos] = useState<any>([]);
  const [assetsSelected, setAssetsSelected] = useState<any[]>([]);
  const [dataItems, setDataItems] = useState(detailData);

  const { showToast } = useCustomToast();

  useEffect(() => {
    if (detailData?.goods_type === GoodTypes.BIEN_CONSUMO) {
      formikSolicitud.setFieldValue('items', detailData?.items || []);
    }
    setColumTableBienes([
      {
        title: 'Item',
        dataIndex: 'index',
        key: 'index',
        align: 'center',
        render: (_: any, __: any, index: number) => index + 1,
      },
      {
        title: 'Código de producto',
        dataIndex: 'product_code',
        key: 'product_code',
        align: 'center',
        render: (data: any) => data ? data : "-"
      },
      {
        title: 'Descripción',
        dataIndex: 'description',
        key: 'description',
        align: 'center',
        render: (data: any) => data ? data : "-"
      },
      {
        title: 'Grupo de bienes',
        dataIndex: 'good_class',
        key: 'good_class',
        align: 'center',
        render: (data: any) => data ? data.group_code + ' - ' + data.name : "-"
      },
      {
        title: 'Unidad de medida',
        dataIndex: 'unit_measurement',
        key: 'unit_measurement',
        align: 'center',
        render: (data: any) => data ? data.name : "-"
      },
      {
        title: 'Cantidad solicitada',
        dataIndex: 'quantity_requested',
        key: 'quantity_requested',
        align: 'center',
        render: (data: any) => data ? data : "-"
      },
      {
        title: 'Cantidad entregada',
        dataIndex: 'quantity_received',
        key: 'quantity_received',
        align: 'center',
        render: (data: any) => (data !== null && data !== undefined ? data : "-")
      },
      {
        title: 'Estado por elemento',
        dataIndex: 'status_manage',
        key: 'status_manage',
        render: (data: any) => data ? data : "-"
      },
      {
        title: 'Acciones',
        key: 'actions',
        render: (item: any) => (
          <>
            <CustomButton
              label="Gestionar"
              onClick={() => handleModalSomeItemsOpen(item)}
              size="middle"
            />
          </>
        ),
      },
    ],)
    setColumTableFijos([
      {
        title: 'Item',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: 'Código / placa',
        dataIndex: 'plate_code',
        key: 'plate_code',
      },
      {
        title: 'Descripción',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Costo histórico',
        dataIndex: 'historical_cost',
        key: 'historical_cost',
        render: (value: number) => 
          value !== null && value !== undefined
            ? new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(value)
            : '-',
      },
      {
        title: 'Responsable',
        dataIndex: 'article',
        key: 'article',
        render: (_: any, record: any) => record.responsible.document + ' - ' +  record.responsible.name + ' ' + record.responsible.last_name,
      },
      {
        title: 'Nueva ubicación',
        dataIndex: 'location',
        key: 'location',
        render: (_: any, record: any) => record.location,
      },
      {
        title: 'Estado por elemento',
        dataIndex: 'status_manage',
        key: 'status_manage',
      },
      {
        title: 'Acciones',
        key: 'actions',
        render: (item: any) => (
          <>
            <CustomButton
              label="Gestionar"
              onClick={() => handleModalSomeItemsOpen(item)}
              size="middle"
            />
            <CustomButton
              label="Eliminar"
              onClick={() => handleDeleteSelectedItems(item)}
              size="middle"
            />
          </>
        ),
      },
    ],)
  }, [detailData]);

  useEffect(() => {
    if (detailData) {
      setDataItems(detailData);
    }
  }, [detailData]);

  const documentColumns = [
    {
      title: 'Item',
      dataIndex: 'index',
      key: 'index',
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
  ];

  //Modales manejadores
  const handleModalSomeItemsOpen = (item:any) => {
    setItemSelected(item);
    setModalManageAll(true);
    formikSolicitud.setFieldValue('status_id', [13,14].includes(item.status_id) ? item.status_id : null);
  }

  const handleDeleteSelectedItems = async(item:any) => {
    setAssetsSelected((prevAssets) => {
      const updatedAssets = prevAssets.filter((asset: any) => asset.id !== item.id);
  
      updateItemsState(updatedAssets);
  
      return updatedAssets;
    });
  }

  const handleModalElementsOpen = () => {
    setModalElements(true);
  };

  const handleModalAssetsOpen = () => {
    setModalAssets(true);
    setAssetsList([]);
  };

  // Modal de gestionar un item
  const handleModalElementsCancel = () => {
    setModalElements(false);
  };

  //Modal de gestionar todos los items
  const handleModalAllItemCancel = () => {
    setModalManageAll(false);
    setLoadingAll(false);
    setItemSelected([]);
  };

  const handleModalAssetsCancel = () => {
    setModalAssets(false);
    setItemSelected([]);
  };

  const handleModalAssetsSave = () => {
    if (itemSelected.length === 0) return;

    const totalSeleccionados = assetsSelected.length + itemSelected.length;
    const maxPermitidos = detailData.items.length;
    
    if (totalSeleccionados > maxPermitidos) {
      showToast('error', `No se puede seleccionar más de ${maxPermitidos} elementos`);
      return;
    }
    setItemSelected([]);
    setAssetsSelected(
      (prevAssets) => {
        const updatedAssets = prevAssets.filter((asset: any) => !itemSelected?.includes(asset.id));
  
        return [...updatedAssets, ...itemSelected];
      }
    );
    formikSolicitud.setFieldValue('items', itemSelected);
    setModalAssets(false);
  };

  const handleItemSave = async () => {
    const sourceItems =
      detailData?.goods_type === GoodTypes.ACTIVO_FIJO
        ? assetsSelected
        : dataItems.items;
  
    const updatedItems = sourceItems.map((item: any) => {
      if (Array.isArray(itemSelected) && itemSelected.includes(item.id)) {
        return {
          ...item,
          status_manage: goodPetitionItems.find(
            (petition: any) => petition.id === formikSolicitud.values.status_id
          )?.name,
          quantity_received: formikSolicitud.values.quantity_received,
          consumer_good_branch_id: formikSolicitud.values.consumer_good_branch_id,
          manage_status_id: formikSolicitud.values.status_id,
          location: location.find(
            (loc: any) => loc.id === formikSolicitud.values.location_id
          )?.name,
        };
      } else if (typeof itemSelected === 'object' && item.id === itemSelected.id) {
        return {
          ...item,
          status_manage: goodPetitionItems.find(
            (petition: any) => petition.id === formikSolicitud.values.status_id
          )?.name,
          quantity_received: formikSolicitud.values.quantity_received,
          consumer_good_branch_id: formikSolicitud.values.consumer_good_branch_id,
          manage_status_id: formikSolicitud.values.status_id,
          location: location.find(
            (loc: any) => loc.id === formikSolicitud.values.location_id
          )?.name,
        };
      }
      return item;
    });
  
    updateItemsState(updatedItems);
    handleModalAllItemCancel();
  };

  const updateItemsState = (updatedItems: any[]) => {
    setAssetsSelected(updatedItems);
  
    setDataItems({
      ...dataItems,
      items: updatedItems,
    });
  
    formikSolicitud.setFieldValue(
      'items',
      updatedItems.map((item: any) => ({
        ...item,
        itemable_id: item.id,
        quantity_received: item.quantity_received,
        consumer_good_branch_id: item.consumer_good_branch_id,
        manage_status_id: item.manage_status_id,
        location_id: item.location_id,
      }))
    );
  };

  useEffect(() => {
    setItemSelected([]);
  }, []);

  return (
    <Fragment>
      <CustomTabs
        defaultActiveKey="1"
        items={[
          {
            key: '1',
            label: (
              <Button type="link" icon={<FileTextOutlined />}>
                Información de solicitud
              </Button>
            ),
            children: (
              <Fragment>
                <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText text="Número de ticket:" strong fontSize="small" />
                      <CustomText
                        text={detailData?.ticket}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText text="Número transacción:" strong fontSize="small" />
                      <CustomText
                        text={detailData?.request_date?.split('-')[0] + detailData?.id_petition}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText text="Tipo de movimiento:" strong fontSize="small" />
                      <CustomText
                        text={detailData?.ticket_type}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText text="Fecha de Solicitud:" strong fontSize="small" />
                      <CustomText
                        text={detailData?.request_date ? detailData?.request_date : "Sin registrar"}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText
                        text="Solicitante:"
                        strong
                        fontSize="small"
                      />
                      <CustomText
                        text={detailData?.document_requester + ' - ' + detailData?.requester}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText
                        text="Tipo de solicitud:"
                        strong
                        fontSize="small"
                      />
                      <CustomText text={detailData?.goods_type} fontSize="middle" />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText
                        text="Dependecia:"
                        strong
                        fontSize="small"
                      />
                      <CustomText text={detailData?.dependency} fontSize="middle" />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText
                        text="Ubicación:"
                        strong
                        fontSize="small"
                      />
                      <CustomText text={detailData?.location} fontSize="middle" />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText
                        text="Jefe de dependencia:"
                        strong
                        fontSize="small"
                      />
                      <CustomText
                        text={detailData?.approved_by ? detailData?.approved_by : 'Sin registrar'}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4 mt-8">
                      <CustomText
                        text="Estado actual:"
                        strong
                        fontSize="small"
                      />
                      <CustomText text={detailData?.status?.status} fontSize="middle" />
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className="mb-4 mt-8">
                      <CustomText
                        text="Observaciones:"
                        strong
                        fontSize="small"
                      />
                      <CustomText text={detailData?.observations} fontSize="middle" />
                    </div>
                  </Col>
                </Row>

                {detailData?.goods_type === GoodTypes.ACTIVO_FIJO && (
                  <>
                    <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
                      <Col span={24}>
                        <div className="mb-4 mt-8">
                          <CustomText
                            text="Articulos solicitados"
                            strong
                            fontSize="small"
                          />
                          <Button
                            type="primary"
                            onClick={() => handleModalElementsOpen()}
                          >Ver artículos solicitados</Button>
                        </div>
                      </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <CustomTextArea
                          label="Observaciones"
                          name="reason"
                          placeholder="Seleccione"
                          value={formikSolicitud.values.reason}
                          error={formikSolicitud.errors.reason}
                          touched={formikSolicitud.touched.reason}
                          onChange={formikSolicitud.handleChange}
                          onBlur={formikSolicitud.handleBlur}
                        />
                      </Col>
                    </Row>
                
                    <Divider />
                
                    <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
                      <Col span={12}>
                        <div className="mb-4 mt-8">
                          <CustomText
                            text="Selector de activos"
                            strong
                            fontSize="small"
                          />
                          <Button
                            type="primary"
                            onClick={handleModalAssetsOpen}
                          >
                            Selector de elementos
                          </Button>
                        </div>
                      </Col>
                
                      {/* <Col span={12}>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'flex-start',
                            gap: '16px',
                            marginTop: '32px',
                          }}
                        >
                          <Upload 
                            name="files"
                            beforeUpload={() => false}
                            onChange={handleUploadChange}
                          >
                            {!formikSolicitud.values.files && (
                              <Button type="primary" icon={<UploadOutlined />}>
                                Adjuntar archivo
                              </Button>
                            )}
                          </Upload>
                
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <Button
                              type="primary"
                              onClick={downloadTemplate}
                            >
                              Descargar plantilla
                            </Button>
                            <Button
                              type="primary"
                              onClick={handleUploadFile}
                            >
                              Validar documento
                            </Button>
                          </div>
                        </div>
                      </Col> */}
                    </Row>
                  </>
                )}

               {detailData?.goods_type === GoodTypes.BIEN_CONSUMO && <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <CustomTextArea
                      label="Observaciones"
                      name="reason"
                      placeholder="Seleccione"
                      value={formikSolicitud.values.reason}
                      error={formikSolicitud.errors.reason}
                      touched={formikSolicitud.touched.reason}
                      onChange={formikSolicitud.handleChange}
                      onBlur={formikSolicitud.handleBlur}
                    />
                  </Col>
                </Row>}

                <GestorTableItems
                  goodsType={detailData?.goods_type}
                  detailData={detailData?.goods_type === GoodTypes.ACTIVO_FIJO ? assetsSelected : dataItems?.items}
                  setDetailData={setAssetsSelected}
                  setModalManageAll={setModalManageAll}
                  columnsFijos={columTableFijos}
                  columnsBienes={columTableBienes}
                  isRoleManage
                  isManage
                  onSelectedRowsChange={(selectedRowKeys: any) =>
                    setItemSelected(selectedRowKeys)
                  }
                />
              </Fragment>
            ),
          },
          {
            key: '2',
            label: (
              <Button type="link" icon={<FileSearchOutlined />}>
                Documentos
              </Button>
            ),
            children: (
              <>
                <CustomTable
                  dataSource={detailData?.documents?.map(
                    (doc: any, index: number) => ({
                      key: index,
                      createdAt: doc.created_at,
                      name: doc.url?.split('/').pop(),
                      link: doc.url,
                    })
                  )}
                  columns={documentColumns}
                  pagination={false}
                />
              </>
            ),
          },
          {
            key: '3',
            label: (
              <Button type="link" icon={<HistoryOutlined />}>
                Historial de la solicitud
              </Button>
            ),
            children: (
              <CustomTable
                columns={[
                  {
                    title: 'Id',
                    dataIndex: 'index',
                    key: 'index',
                    render: (_: any, __: any, index: number) => index + 1,
                  },
                  {
                    title: 'Fecha',
                    dataIndex: 'date',
                    key: 'date',
                  },
                  {
                    title: 'Usuario',
                    dataIndex: 'user',
                    key: 'user',
                    render: (_: any, record: any) => record.document +  ' - ' + record.user,
                  },
                  {
                    title: 'Observaciones',
                    dataIndex: 'observations',
                    key: 'observations',
                  },
                  {
                    title: 'Estado',
                    dataIndex: 'comment',
                    key: 'comment',
                    render: (text: string) => {
                      if (!text) return '';
                      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
                    },
                  },
                ]}
                dataSource={
                  detailData?.history?.map((item: any, index: number) => ({
                    key: index,
                    date: item.date,
                    comment: item.comment,
                    user: item.user,
                    document: item.document,
                    observations: item.observations,
                  })) || []
                }
                pagination={false}
              />
            ),
          },
        ]}
      />
      <Divider />

      {modalManageAll && <CustomModal
        title="Gestionar"
        labelSubmit="Aceptar"
        open={modalManageAll}
        width={800}
        onCancel={handleModalAllItemCancel}
        onSave={handleItemSave}
        isLoadingSave={loadingAll}
        centered
        disabledBtn={
          detailData?.goods_type === GoodTypes.ACTIVO_FIJO
            ? !(
                formikSolicitud.values.status_id &&
                (
                  formikSolicitud.values.status_id === 13
                    ? formikSolicitud.values.location_id
                    : true
                )
              )
            : !(
                formikSolicitud.values.status_id &&
                formikSolicitud.values.quantity_received != null &&
                (
                  formikSolicitud.values.status_id === 13
                    ? formikSolicitud.values.consumer_good_branch_id
                    : true
                )
              )
        }
      >
        <GDContentModalItems
          formik={formikSolicitud}
          detailData={detailData}
          goodPetitionItems={goodPetitionItems}
          locations={location}
          goodsType={detailData?.goods_type}
          itemSelected={itemSelected}
        />
      </CustomModal>}

      <CustomModal
        title="Elementos seleccionados"
        labelCancel='Finalizar'
        open={modalElements}
        width="90vw"
        onCancel={handleModalElementsCancel}
        isLoadingSave={loadingAll}
      >
        <CustomTable
            rowKey="id"
            columns={[
              {
                title: 'Item',
                dataIndex: 'index',
                key: 'index',
                render: (_: any, __: any, index: number) => index + 1,
              },
              {
                title: 'Artículo',
                dataIndex: 'article',
                key: 'article',
                render: (_: any, record: any) => record.item.code + ' - ' + record.item.name,
              },
              {
                title: 'Clase de activos',
                dataIndex: 'asset_class',
                key: 'asset_class',
                render: (_: any, record: any) => record.asset_class.code + ' - ' + record.asset_class.name,
              },
            ]}
            dataSource={(detailData?.items ?? []).filter((item: any) => item.key !== 'actions')}
            scroll={{ x: 'max-content' }}
            pagination={false}
          />
      </CustomModal>

      {modalAssets && <CustomModal
        title="Selector de activos"
        labelSubmit="Añadir"
        open={modalAssets}
        width="90vw"
        onCancel={handleModalAssetsCancel}
        onSave={handleModalAssetsSave}
        isLoadingSave={loadingAll}
      >
      <AssetSelector
          open={modalAssets}
          detailData={assetsList}
          goodsType="Activo fijo"
          multiple
          sectional_id={detailData?.sectional_id}
          columnsFijos={[
            {
              title: '#',
              dataIndex: 'index',
              key: 'index',
              render: (_: any, __: any, index: number) => index + 1,
            },
            {
              title: 'Código / placa',
              dataIndex: 'plate_code',
              key: 'plate_code',
            },
            {
              title: 'Descripción',
              dataIndex: 'description',
              key: 'description',
            },
            {
              title: 'Grupo de activos',
              dataIndex: 'asset_group',
              key: 'asset_group',
              render: (_: any, record: any) => record.asset_group?.code + ' - ' + record.asset_group?.name,
            },
            {
              title: 'Clase de activos',
              dataIndex: 'asset_class',
              key: 'asset_class',
              render: (_: any, record: any) => record.asset_class?.code + ' - ' + record.asset_class?.name,
            },
            {
              title: 'Artículo',
              dataIndex: 'item',
              key: 'item',
              render: (_: any, record: any) => record.item?.code + ' - ' + record.item?.name,
            },
            {
              title: 'Responsable',
              dataIndex: 'responsible',
              key: 'responsible',
              render: (_: any, record: any) => record.responsible?.document + ' - ' + record.responsible?.name + ' ' + record.responsible?.last_name,
            },
            {
              title: 'Ubicación',
              dataIndex: 'location',
              key: 'good_status',
              render: (_: any, record: any) => record.location ? (record.location?.code + ' - ' + record.location?.name) : 'N/A',
            },
            {
              title: '¿es un vehículo?',
              dataIndex: 'is_vehicle',
              key: 'is_vehicle',
              width: 120,
              render: (_: any, record: any) => record.is_vehicle ? 'Sí' : 'No',
            },
          ]}
          onSelectedRowsChange={(selectedRowKeys: any) =>
            setItemSelected(selectedRowKeys)
          }
        />
      </CustomModal>}
    </Fragment>
  );
};

export default GoodsDetailView;
